"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const logs_1 = require("@ledgerhq/logs");
const account_1 = require("../../account");
const js_transaction_1 = require("./js-transaction");
const typhonjs_1 = require("@stricahq/typhonjs");
const js_buildTransaction_1 = require("./js-buildTransaction");
/**
 * Returns the maximum possible amount for transaction
 *
 * @param {Object} param - the account, parentAccount and transaction
 */
const estimateMaxSpendable = ({ account, parentAccount, transaction, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (account.type === "TokenAccount") {
        return account.balance;
    }
    const dummyRecipient = "addr1qyqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqv2t5am";
    const a = (0, account_1.getMainAccount)(account, parentAccount);
    const t = Object.assign(Object.assign(Object.assign({}, (0, js_transaction_1.createTransaction)()), transaction), { recipient: dummyRecipient, 
        // amount field will not be used to build a transaction when useAllAmount is true
        amount: new bignumber_js_1.BigNumber(0), useAllAmount: true });
    let typhonTransaction;
    try {
        typhonTransaction = yield (0, js_buildTransaction_1.buildTransaction)(a, t);
    }
    catch (error) {
        (0, logs_1.log)("cardano-error", "Failed to estimate max spendable: " + String(error));
        return new bignumber_js_1.BigNumber(0);
    }
    const transactionAmount = typhonTransaction
        .getOutputs()
        .filter(o => !(o.address instanceof typhonjs_1.address.BaseAddress) ||
        !(o.address.paymentCredential.type === typhonjs_1.types.HashType.ADDRESS) ||
        o.address.paymentCredential.bipPath === undefined)
        .reduce((total, o) => total.plus(o.amount), new bignumber_js_1.BigNumber(0));
    return transactionAmount;
});
exports.default = estimateMaxSpendable;
//# sourceMappingURL=js-estimateMaxSpendable.js.map